import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { get } from "../../_services/apiService";
import { endpoints, Image_BASE_URL } from "../../_config";
import { use } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { get_cart_Data, incrQuantity, decrQuantity, addToCart, buyNow } from '../../redux/action';
import { toast } from "react-toastify";

const ProductCategories = () => {

    const loginId = localStorage.getItem('loginId');
    const [openCategory, setOpenCategory] = useState(null);
    const [activeProduct, setActiveProduct] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const productcategoryid = localStorage.getItem("productcategoryId");

    /// const cartData = useSelector((state) => state.cartReducer.cart) || [];

    // const cartQuantity = cartData.find(cartItem => Number(cartItem.productId) === Number(lpId));

    const initialQuantity = 1;


    // Function to toggle categories
    const toggleCategory = (category, id) => {
        setOpenCategory(openCategory === category ? null : category);
        setActiveProduct(null); // Reset active product when category changes
        getProductDetailBycategorysubcategory(id, 0);

    };

    // Function to toggle products
    const toggleProduct = (product) => {
        setActiveProduct(product);
    };

    const [searchTerm, setSearchTerm] = useState('');
    const [productCategoryData, setProductCategoryData] = useState();
    const [productData, setProductData] = useState();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [productDetailById, setProductDetailById] = useState([]);
    const [serchingData, setSerchingData] = useState([]);

    const getProductCategorywithsubcategory = async () => {
        try {
            const response = await get(endpoints.GetProductCategorywithsubcategory)
            if (response.isSuccess === 200) {
                setProductCategoryData(response.data);
            } else {
                setProductCategoryData([]);

            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const getProductDetailBycategorysubcategory = async (categoryId, subcategoryId) => {
        try {
            const response = await get(endpoints.GetProductDetailBycategorysubcategory + "?pCategoryId=" + categoryId + "&pSubCategoryId=" + subcategoryId)
            if (response.isSuccess === 200) {
                setProductData(response.data);
                if (categoryId == 0 && subcategoryId == 0) {
                    setSerchingData(response.data);
                }


            } else {
                setProductData([]);

            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }

    };

    const [formData, setFormData] = useState({
        cartItemId: 0,
        productId: 0,
        loginId: loginId ? Number(loginId) : 0,
        buyStatus: 1,
        quantity: 0,
        isActive: true,
        createdBy: 0,
        unitPrice: 0,
        totalAmount: 0
    });

    useEffect(() => {
        getProductCategorywithsubcategory();

        if (productcategoryid != null && productcategoryid > 0) {
            getProductDetailBycategorysubcategory(productcategoryid, 0);
        } else {
            getProductDetailBycategorysubcategory(0, 0);
        }


        if (formData.productId) { // Ensure formData has been set properly
            try {
                dispatch(addToCart(formData));

            } catch (error) {
                toast.error("Error occurred while adding to cart.");
            }
        }

    }, [formData]);

    const onProductDetail = (productId) => {
        navigate(`/product-detail/${productId}`)
    }
    const handleClick = (item) => {
        //   onAddCart(item); // Add to Quote functionality
        navigate(`/product-detail/${item.productId}`); // Navigate to product detail
    };



    const onAddCart = async (item) => {

        setProductDetailById(item);

        setFormData({
            cartItemId: 0,
            productId: item.productId,
            loginId: loginId ? Number(loginId) : 0,
            buyStatus: 1,
            quantity: initialQuantity,
            isActive: true,
            createdBy: 0,
            unitPrice: item.unitPrice || 0,
            totalAmount: item.unitPrice || 0
        })



        // navigate('/add-quotation');
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);

        const filteredData = serchingData.filter((item) =>
            item.displayName.toLowerCase().includes(event.target.value.toLowerCase())
        );
        if (searchTerm === "" || event.target.value === "") {
            setProductData(serchingData);
        } else {
            setProductData(filteredData);
        }
    };



    // setProductData(filteredData);


    return (
        <section className="same_space product_space">
            <div className="container">
                <div className="our_product_tab_wepper_main row">
                    <div className="nav flex-column nav-pills our_product_tab_wepper col-lg-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <h2>Categories</h2>

                        {/* Air Conditioners */}


                        {productCategoryData?.map((item, i) => {
                            return (
                                <div key={i}>
                                    {/* Toggle button for category */}
                                    <button className="nav-link" onClick={() => toggleCategory(item.categoryName, item.productCategoryId)}>
                                        {item.categoryName}
                                        <i
                                            className={`fa-solid fa-chevron-right ${openCategory === item.categoryName ? "rotate-icon" : ""}`}
                                        ></i>
                                    </button>

                                    {/* Display subcategories if the category is open */}
                                    {openCategory === item.categoryName && (
                                        <ul className="child-dropdown">
                                            {item.subCategoryDtos?.map((element, j) => (
                                                <li key={j} onClick={() => getProductDetailBycategorysubcategory(element.productCategoryId, element.productSubCategoryId)}>
                                                    {element.productSubCategoryName}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            );
                        })}

                    </div>


                    {/* Product Display */}
                    <div className="tab-content col-lg-9" id="v-pills-tabContent">
                        <>
                            <div className="d-flex justify-content-end">
                                <div className="form-group serch_wepper email_wepper_Address placeholder_color_chnge">
                                    {/* <label className="fieldlabels">
                                    Enter Your Address <span>|</span>
                                </label> */}

                                    <input className="form-control" style={{ backgroundColor: 'transparent', border: 'none' }}
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleSearchChange} // Use the separate function
                                    />
                                </div>
                            </div>

                            <br></br>
                            <div className="">
                                <div className="our_product_inner_wepper row">
                                    {productData?.length > 0 ? (
                                        productData?.map((item, i) => {
                                            console.log(item,'dfgfgdfgdfgdfg')
                                            return (
                                                <>
                                                    <div className="our_product_inner col-lg-4 col-md-4 col-sm-4">
                                                        <div className="air_conditioners_box"><span onClick={() => onProductDetail(item.productId)}
                                                            data-discover="true">

                                                            {item.productImageDtos?.map((imageitem, j) => (
                                                                imageitem.isHeader ?
                                                                    <img src={`${imageitem?.imgPath}`} alt="" />
                                                                    : <img src={`${item.productImageDtos[0]?.imgPath}`} alt="" />
                                                            ))}

                                                        </span></div>
                                                        <div className="air_conditioners_bg">
                                                            <img src="images/air-conditioners.svg" alt="" className="w-100" />
                                                            <div className="air_conditioner_content">
                                                                <h2>{item.displayName}</h2>
                                                                <p>Categories : {item.categoryName}, {item.productSubCategoryName}</p>
                                                                {/* <span><Link to={`/product-detail/${item.productId}`}>More Detail &gt;</Link> </span> */}
                                                                {/* <Link to="/add-quotation" data-discover="true">Add To Quotation</Link> */}
                                                                <div className="d-flex gap-2" style={{
                                                                    margin: '25px 10px'
                                                                }}>
                                                                    <button onClick={() => onAddCart(item)} className="add_to_Quotation_btn">Add To Quote </button>
                                                                    <button onClick={() => handleClick(item)} className="add_to_Quotation_btn">More Detail </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })) : (
                                        <p>Product not found in this category</p>
                                    )}
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductCategories;
